<template>
  <div class="nav-item dropdown" id="locale-dropdown">
    <Button class="nav-link dropdown-toggle user-dropdown-toggle px-0 py-2" @click.prevent="localeMenuRef?.toggle($event)" variant="link">
      {{ locale }}
    </Button>

    <Menu ref="localeMenuRef" :model="localeMenuItems" :popup="true"/>
  </div>
</template>

<script setup>
import {computed, onMounted, onUnmounted, ref} from "vue";
import {useI18n} from "vue-i18n";
import EventBus from "@/util/eventBus";

const {t, locale, availableLocales} = useI18n();
const localeMenuRef = ref(null);

const localeMenuItems = computed(() => [
  {label: "ENG", command: () => switchLocale("ENG")},
  {label: "EST", command: () => switchLocale("EST")},
  {label: "RUS", command: () => switchLocale("RUS")},
]);

onMounted(() => {
  EventBus.$on("switch-locale", switchLocale);

  if (localStorage.lang && availableLocales.includes(localStorage.lang)) {
    locale.value = localStorage.lang;
  } else {
    switchLocaleInLocalStorage(locale.value);
  }
});

onUnmounted(() => {
  EventBus.$off("switch-locale", switchLocale);
});

const switchLocaleInLocalStorage = (newLocale) => {
  localStorage.setItem("lang", newLocale);
};

const switchLocale = (newLocale) => {
  if (locale.value !== newLocale) {
    locale.value = newLocale;
    switchLocaleInLocalStorage(locale.value);
    EventBus.$emit("locale", locale.value);
  }
};
</script>

<style lang="scss" scoped>
#locale-dropdown > :deep(.nav-link) {
  white-space: nowrap;
}
</style>
